import { random } from "lodash";

export function randomElement(options) {
  return options.length > 0 ? options[random(0, options.length - 1)] : null;
}

export function randomString() {
  return randomElement(["xyz", "Иванов", "Пётр Первый", "1234", "945-999-99-99", "f@#%*", ""]);
}

export function updateTables(datas) {
  let newTables = {};
  const keys = [
    "tbl-1-1", "tbl-1-2", "tbl-1-3", "tbl-1-4", "tbl-1-5", "tbl-1-6-1", "tbl-1-6-2", "tbl-1-7", 
    "tbl-2-1", "tbl-2-2-1", "tbl-2-2-2", "tbl-2-2-3", "tbl-2-3-1", "tbl-2-3-2", "tbl-2-3-3", "tbl-2-4-1", 
    "tbl-2-4-2", "tbl-5-1", "tbl-5-2", "tbl-5-3",
  ];
  for(let i = 0; i < keys.length; i++){
    newTables[keys[i]] = {};
    newTables[keys[i]].leftEmpty = false;
    if(datas[keys[i]]){
      if(Array.isArray(datas[keys[i]])){
        newTables[keys[i]].data = datas[keys[i]];
      }
      else {
        newTables[keys[i]] = datas[keys[i]];
      }
      
    }
    else {
      newTables[keys[i]].data = [];
    }
  }
  return newTables;
}
